/** Frontend category keys → backend filter / isin-category API keys. */
const CATEGORY_API_ALIASES = {
  slr: 'government',
  sdl: 'stategovernment',
};

/**
 * Maps UI category keys to backend category parameter values.
 * e.g. Instruments "slr" → "government", "sdl" → "stategovernment".
 */
export function mapCategoryForFilterApi(category) {
  if (!category || category === 'ALL') return category;
  const key = String(category).toLowerCase();
  return CATEGORY_API_ALIASES[key] || key;
}

export function isRbiGovCategory(category) {
  const mapped = mapCategoryForFilterApi(category);
  return mapped === 'government' || mapped === 'stategovernment';
}

export function isCentralGovCategory(category) {
  return mapCategoryForFilterApi(category) === 'government';
}

export function isStateGovCategory(category) {
  return mapCategoryForFilterApi(category) === 'stategovernment';
}

/** True when any configured category is central or state government (RBI universe). */
export function categoriesIncludeRbiGov(categories) {
  const cats = Array.isArray(categories) ? categories : [];
  return cats.some((cat) => isRbiGovCategory(cat));
}

export function categoriesIncludeCentralGov(categories) {
  const cats = Array.isArray(categories) ? categories : [];
  return cats.some((cat) => isCentralGovCategory(cat));
}

export function categoriesIncludeStateGov(categories) {
  const cats = Array.isArray(categories) ? categories : [];
  return cats.some((cat) => isStateGovCategory(cat));
}
